import { graphql } from "@/lib/gql/__generated__";

export const BasicCustomMailSettingUpdate = graphql(/* GraphQL */ `
	mutation BasicCustomMailSettingUpdate($input: BasicCustomMailSettingInput!) {
		basicCustomMailSettingUpdate(input: $input) {
			basicCustomMailSetting {
				id
				mailFooterExternalLink
				forReservation {
					atCreated {
						text
					}
					atUpdated {
						text
					}
					atCanceled {
						text
					}
					atCheckInBefore_07days {
						text
						shouldSendEmail
					}
					atCheckInBefore_01days {
						text
						shouldSendEmail
					}
					atCheckInBefore_00days {
						text
						shouldSendEmail
					}
					atCheckOutAfter_01days {
						text
						shouldSendEmail
					}
					atRequest {
						text
					}
					atConfirmed {
						text
					}
					atDeclined {
						text
					}
				}
				forShopping {
					atCreated {
						text
					}
				}
			}
			userErrors
		}
	}
`);
